/* filter data for shipment */


export const namespaced = true

export const state = {
    wholesaler: null,
}

export const mutations = {
    SET_WHOLESALER(state, value) {
        state.wholesaler = value
    },
}
export const actions = {
    setWholesaler({commit}, items) {
        commit('SET_WHOLESALER', items)
    },
}
export const getters = {
    getWholesaler: state => {
        return state;
    },
}